import { apiHandler } from "../../lib/apiHandler";
import { toast } from "react-toastify";
import i18n from "../../assets/i18n";

export const ADD_PS_CALCULATOR_ITEM = "ADD_PS_CALCULATOR_ITEM";
export const EDIT_PS_CALCULATOR_ITEM = "EDIT_PS_CALCULATOR_ITEM";
export const DELETE_PS_CALCULATOR_ITEM = "DELETE_PS_CALCULATOR_ITEM";
export const GET_PS_CALCULATOR_ITEMS = "GET_PS_CALCULATOR_ITEMS";
export const GET_PS_CALCULATOR_DOC_URL = "GET_PS_CALCULATOR_DOC_URL";

export const getPsCalculatorItems = () => async (dispatch) => {
  dispatch({
    type: GET_PS_CALCULATOR_ITEMS,
    payload: { loading: true },
  });
  const res = await apiHandler("get", "/ps-calculator");
  dispatch({
    type: GET_PS_CALCULATOR_ITEMS,
    payload: res.data,
  });
};

export const addPsCalculatorItem = (item) => async (dispatch) => {
  try {
    dispatch({
      type: ADD_PS_CALCULATOR_ITEM,
      payload: { loading: true },
    });
    const res = await apiHandler("post", "/ps-calculator", item);
    dispatch({
      type: ADD_PS_CALCULATOR_ITEM,
      payload: res.data,
    });
    toast.success(i18n.t("Item added successfully"));
  } catch (error) {
    const errMessage =
      error?.message || i18n.t("Something went wrong, try again");
    console.error(errMessage);
    toast.error(errMessage);
    dispatch({
      type: ADD_PS_CALCULATOR_ITEM,
      payload: { item: null, refetch: false },
    });
  }
};

export const editPsCalculatorItem = (item) => async (dispatch) => {
  try {
    dispatch({
      type: EDIT_PS_CALCULATOR_ITEM,
      payload: { loading: true },
    });
    const res = await apiHandler("put", `/ps-calculator/${item.id}`, item);
    dispatch({
      type: EDIT_PS_CALCULATOR_ITEM,
      payload: { item: res.data, refetch: true },
    });
    toast.success(i18n.t("Item updated successfully"));
  } catch (error) {
    const errMessage =
      error?.message || i18n.t("Something went wrong, try again");
    console.error(errMessage);
    toast.error(errMessage);
    dispatch({
      type: EDIT_PS_CALCULATOR_ITEM,
      payload: { item: null, refetch: false },
    });
  }
};

export const deletePsCalculatorItem = (id) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_PS_CALCULATOR_ITEM,
      payload: { loading: true },
    });
    await apiHandler("del", `/ps-calculator/${id}`);
    dispatch({
      type: DELETE_PS_CALCULATOR_ITEM,
      payload: { id, refetch: true },
    });
    toast.success(i18n.t("Item deleted successfully"));
  } catch (error) {
    const errMessage =
      error?.message || i18n.t("Something went wrong, try again");
    console.error(errMessage);
    toast.error(errMessage);
  }
};

export const sendEmail = (id, email) => async () => {
  try {
    await apiHandler("post", `/ps-calculator/send-email`, { id, email });
    toast.success(i18n.t("Email sent successfully"));
  } catch (error) {
    const errMessage =
      error?.message || i18n.t("Something went wrong, try again");
    console.error(errMessage);
    toast.error(errMessage);
  }
};

export const getPsCalculatorSowPdf = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_PS_CALCULATOR_DOC_URL,
      payload: { loading: true },
    });
    const res = await apiHandler("get", `/ps-calculator/get-doc-url/${id}`);
    dispatch({
      type: GET_PS_CALCULATOR_DOC_URL,
      payload: { docUrl: res.data.doc_url, loading: false },
    });
  } catch (error) {
    const errMessage =
      error?.message || i18n.t("Something went wrong, try again");
    console.error(errMessage);
    toast.error(errMessage);
    dispatch({
      type: GET_PS_CALCULATOR_DOC_URL,
      payload: { docUrl: null, loading: false },
    });
  }
};
